import { connect } from 'react-redux'
import StompunktToolbar from './StompunktToolbar'
import { toggleCurrentStompunkt, zoomToCurrentStompunkt, togglePermalink, openPdf } from '../../actionCreators'
import { currentStompunktIsSelected, currentHeavyStompunkt } from '../../selectors/currentStompunkt'

const mapStateToProps = (state, ownProps) => ({
	selected: currentStompunktIsSelected(state),
	loaded: currentHeavyStompunkt(state).status === "SUCCESS",
	pdfUrl: `/export/pdf/${state.currentStompunkt}?srid=${state.srid}`
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	onToggleSelect: () => dispatch(toggleCurrentStompunkt()),
	onViewOnMap: () => dispatch(zoomToCurrentStompunkt()),
	onLink: () => dispatch(togglePermalink()),
	onOpenPdf: () => dispatch(openPdf())
})

export default connect(mapStateToProps, mapDispatchToProps)(StompunktToolbar);



// WEBPACK FOOTER //
// ./src/components/Stompunkt/StompunktToolbarContainer.js